<template>
  <div class="context-tree-select-mask" @click="hideTreeSelectMenu">
    <!-- Tree-Context Selector -->
    <div class="context-tree-select" v-bind:style="{ top: posY, left: posX }">
      <select v-if="showOptions" @change="selection" @click="preventEventBubbling">
        <option value="-1">Show in Tree ...</option>
        <!-- TODO: avoid code doubling. See "username" method in detail-panel.vue -->
        <option v-for="rootNode in entries" :value="rootNode.uri.slice('infobits.tree.'.length)">
          {{rootNode.uri.slice('infobits.tree.'.length)}}
        </option>
      </select>
      <span class="label" v-if="!showOptions">Infobit is not yet assigned to any tree</span>
    </div>
  </div>
</template>

<script type="text/javascript">

export default {

  props: ['entries', 'x', 'y', 'infobitId'],

  data () {
    return {
      posX: this.x + 'px',
      posY: this.y + 'px'
    }
  },

  computed: {

    infobit () {
      return this.$store.state.detailPanel.infobit
    },

    showOptions () {
      return (this.entries && this.entries.length > 0)
    }
  },

  methods: {

    selection: function (event) {
      this.$emit('selection', { treeName: event.target.value, infobitId: this.infobitId })
      this.$emit('close')
    },

    hideTreeSelectMenu: function () {
      this.$emit('close')
    },

    preventEventBubbling: function (event) {
      event.stopPropagation()
    }
  }
}
</script>

<style>
.context-tree-select-mask {
  position: fixed;
  top: 0px; left: 0px;
  width: 100%;
  height: 100%;
  z-index: 2010;
}

.context-tree-select {
  position: absolute;
  padding: 1em;
  background-color: #fff;
  border: 1px dotted lightgray;
}

.context-tree-select h3 {
  margin-top: 0em;
}
</style>



// WEBPACK FOOTER //
// context-tree-select.vue?63483219